const ISSUE_INVOICE_OPTS = [
	{
		label: 'Sim',
		value: 'yes',
	},
	{
		label: 'Não',
		value: 'no',
	},
];

export {ISSUE_INVOICE_OPTS};
